import React from 'react';

const EnvironmentBanner = () => {
        const hostname = window.location.hostname;
        const isDevelopment = hostname === 'localhost' || hostname.includes('develop');
        const isStaging = hostname.includes('staging');

        if (!isDevelopment && !isStaging) {
                return null;
        }

        const bgColor = isDevelopment ? 'bg-red-600' : 'bg-green-600';
        const label = isDevelopment ? 'Development' : 'Staging (rc)';

        return (
                <div className="fixed top-0 left-0 overflow-hidden w-40 h-40 pointer-events-none z-[9999]">
                        <div
                                className={`absolute ${bgColor} text-white text-sm font-bold py-1.5 text-center shadow-lg`}
                                style={{
                                        width: '220px',
                                        left: '44px',
                                        top: '44px',
                                        transform: 'translate(-50%, -50%) rotate(-45deg)',
                                }}
                        >
                                {label}
                        </div>
                </div>
        );
};

export default EnvironmentBanner;
